import React from 'react'
import {Route, Switch, Redirect} from 'react-router-dom';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import {createStore, applyMiddleware, compose} from 'redux';
import reducers from './store/reducers';
import App from './App';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

const AppRoot = () => {
    return (
        <Provider store={store}>
            <App/>
        </Provider>
    );
};

export default AppRoot;
